import Color from '../Color.js';
const digits = '0123456789abcdef';

const { floor, random } = Math;

export default () => {
    let code = '#';
    for (let i = 0; i < 6; i++) {
        code += digits.charAt(floor(random() * 16));
    }
    return new Color(code, 'hex');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/generator/random.js
// module id = 2544
// module chunks = 6